module.exports = __webpack_public_path__ + "img/checkup-gift3.e7b5cebc.png";